/**
 * comment模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const comment = {
  // 创建评论
  createComment(params) {
    return $http.post(`${global.API_URL}/sme/comment/create`,params);
  },
  // 查询评论列表
  queryCommentsByTicketEntityId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/comment/queryCommentsByTicketEntityId`,param);
  }
}

export default comment;



// WEBPACK FOOTER //
// ./src/api/comment.js